export default {
  SET_LANGUAGE(state, payload) {
    state.language = JSON.parse(localStorage.getItem('language')) && payload
  },
}
